import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import {
  claimAttendance,
  claimDailyCoins,
  drawGacha,
  fetchCardInventory,
} from '../api/inventory';
import {
  AttendanceClaimResult,
  DailyClaimResult,
  GachaDrawRequest,
  GachaDrawResult,
} from '../types/cards';
import { UserProfile } from '../types/profile';

const CARD_INVENTORY_QUERY_KEY = ['card-inventory'];
const PROFILE_QUERY_KEY = ['profile'];

export function useCardInventory(enabled = true) {
  return useQuery({
    queryKey: CARD_INVENTORY_QUERY_KEY,
    queryFn: fetchCardInventory,
    staleTime: 1000 * 60,
    enabled,
  });
}

export function useClaimDailyCoins() {
  const queryClient = useQueryClient();

  return useMutation<DailyClaimResult, unknown, void>({
    mutationFn: () => claimDailyCoins(),
    onSuccess: (data) => {
      // 서버 응답의 total로 프로필 캐시 즉시 업데이트
      queryClient.setQueryData<UserProfile | null>(
        PROFILE_QUERY_KEY,
        (old) => {
          if (!old) return old;
          return { ...old, currency: data.total };
        }
      );
      void queryClient.invalidateQueries({ queryKey: CARD_INVENTORY_QUERY_KEY });
    },
  });
}

export function useClaimAttendance() {
  const queryClient = useQueryClient();

  return useMutation<AttendanceClaimResult, unknown, void>({
    mutationFn: () => claimAttendance(),
    onSuccess: (data) => {
      // 서버 응답의 total로 프로필 캐시 즉시 업데이트
      queryClient.setQueryData<UserProfile | null>(
        PROFILE_QUERY_KEY,
        (old) => {
          if (!old) return old;
          return { ...old, currency: data.total };
        }
      );
      void queryClient.invalidateQueries({ queryKey: CARD_INVENTORY_QUERY_KEY });
    },
  });
}

export function useGachaDraw() {
  const queryClient = useQueryClient();

  return useMutation<GachaDrawResult, unknown, GachaDrawRequest>({
    mutationFn: drawGacha,
    onSuccess: (data) => {
      // 서버 응답의 totalCurrency로 프로필 캐시 즉시 업데이트
      queryClient.setQueryData<UserProfile | null>(
        PROFILE_QUERY_KEY,
        (old) => {
          if (!old) return old;
          return { ...old, currency: data.totalCurrency };
        }
      );
      void queryClient.invalidateQueries({ queryKey: CARD_INVENTORY_QUERY_KEY });
    },
  });
}


